const DocumentLanguagePort = {
  add: function (app) {
    app.ports.setDocumentLanguage.subscribe((code) => {
      document.documentElement.lang = code;
    });
  },
};

module.exports = DocumentLanguagePort;
